function Active() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none" viewBox="0 0 12 13">
      <path fill="#5ACD8F" d="M12 9.75v-6.5L6 0 0 3.25v6.5L6 13l6-3.25z" />
    </svg>
  )
}

export default Active
